/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum DisplayBillingRate {
  daily = "daily",
  hourly = "hourly",
  none = "none",
  weekly = "weekly",
}

export const DisplayBillingRateDisplay: Record<DisplayBillingRate, string> = {
  [DisplayBillingRate.daily]: "Daily",
  [DisplayBillingRate.hourly]: "Hourly",
  [DisplayBillingRate.none]: "None",
  [DisplayBillingRate.weekly]: "Weekly",
};
